<template>
  <div>
    <h1>{{ pageTitle }}</h1>
    <div class="columns">
      <color
        hex="#356E7B"
        rgb="53, 110, 123"
        cmyk="81, 45, 42, 13"
        ral="5025"
        pantone="7475 C"
        name="Tekstur Blue"
      ></color>
      <color
        hex="#231f20"
        rgb="35, 31, 32"
        cmyk="70, 67, 64, 74"
        ral="8022"
        pantone="Black C"
        name="Tekstur Gray"
      ></color>
      <color
        hex="#1B3940"
        rgb="27, 57, 62"
        cmyk="87, 62, 57, 50"
        ral="5012"
        pantone="546 C"
        name="Tekstur Dark Blue"
      ></color>
    </div>
    <div class="columns">
      <color hex="#63CDE5" rgb="99, 205, 229" cmyk="57, 10, 0, 10" name="Tekstur Light Blue"></color>
      <color hex="#FFB26E" rgb="255, 178, 110" cmyk="0, 30, 57, 0" name="Tekstur Tan"></color>
      <color hex="#111111" rgb="17, 17, 17" cmyk="73, 67, 66, 83" name="Black (Header)"></color>
      <spacer/>
    </div>
    <div class="columns">
      <color hex="#313131" rgb="49, 49, 49" cmyk="70, 64, 62, 60" name="Dark Gray (Body)"></color>
      <color hex="#555555" rgb="85, 85, 85" cmyk="64, 56, 55, 31" name="Medium Gray (Subheader)"></color>
      <color hex="#eeeeee" rgb="238, 238, 238" cmyk="5, 4, 4, 0" name="Light Gray (Accents)"></color>
    </div>
    <div id="gradient-container">
        <div id="gradient">
            <div class="columns">
                <div class="column">
                    <p><strong>Brand Gradient</strong> <br>Top: Pure White (#ffffff)<br> Bottom: Tekstur Blue (#356E7B)<br>Split Location: 60%<br>Opacity: 95%<br><em>The image behind the gradient should be as dark as possible.</em></p>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Color from '@/components/Color.vue'
export default {
  components: {
    Color
  },
  data () {
    return {
      pageTitle: 'Brand Colors'
    }
  }
}
</script>

<style lang="scss">
$white: #ffffff;
$blue: #356E7B;
#gradient-container {
    border: 1px solid $blue;
    margin-top: 50px;
    width: 500px;
    max-width: 100%;
}
#gradient {
    position: relative;
    background: linear-gradient(rgba($white,.95),rgba($blue,.95) 60%),url(https://tekstur.com/assets/gallery/65.jpg);
    background-size: cover;
    background-position: center center;
    height: 700px;
    max-height: 80vh;
    color: $white;
    margin: 10px;
    padding: 15px;
    h3 {
        color: $white;
        small {
            color: $white;
        }
    }
    p {
        position: absolute;
        bottom: 15px;
        left: 15px;
        strong {
            color: $white;
            font-size: 24px;
        }
    }
}
</style>
